<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align:center">Born on the eve of the second world war, living in the Midlands, I can remember being wakened as Coventry was being bombed. The early hours of D day seeing the sky filled with aircraft heading for Normandy, the roar of the engines making the windows rattle.</p>
<p style="text-align:center">Spent five years in the RAF then drifted into the motor industry until retirement. Now living on the South Coast with a one tenth share of an ex fishing boat and trying to become a writer.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7ac1e057